<template>
  <GenericLayout
    :title="$t('PROFILE.TITLE')"
    class="profile py-4 fill-height"
  >
    <div
      class="d-flex justify-center py-2"
      @click="showEditPicModal()"
    >
      <BaseAvatar
        class="avatar"
        size="90"
        :img="pic"
      />
    </div>
    <h1 class="text-center">
      {{ $store.state.session.name }}
    </h1>

    <div class="profile-container">
      <v-list class="mt-0" three-line>
        <v-list-item @click="showClassModeModal()">
          <v-list-item-content>
            <v-list-item-title class="mb-1">
              {{ $t('PROFILE.CLASS_MODE.TITLE') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('PROFILE.CLASS_MODE.DESCRIPTION') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />

      <v-list class="mt-0" three-line>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="mb-1">
              {{ $t('PROFILE.LANG.TITLE') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('PROFILE.LANG.DESCRIPTION') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  small
                  v-on="on"
                >
                  {{ $t('LOCALE_NAME', $store.state.settings.lang) }}
                  <v-icon right>
                    expand_more
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="locale in $i18n.availableLocales"
                  :key="locale"
                  @click="setLocale(locale)"
                >
                  <v-list-item-title>
                    {{ $t('LOCALE_NAME', locale)}}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <v-divider />

      <v-list class="mt-0" three-line>
        <v-list-item @click="share()">
          <v-list-item-content>
            <v-list-item-title class="mb-1">
              {{ $t('PROFILE.SHARE.TITLE') }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-0">
              {{ $t('PROFILE.SHARE.DESCRIPTION') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />

      <v-list class="mt-0" three-line>
        <v-list-item @click="$router.push({ name: 'iceberg' })">
          <v-list-item-content>
            <v-list-item-title class="mb-1">
              {{ $t('PROFILE.ICEBERG.TITLE') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('PROFILE.ICEBERG.DESCRIPTION') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon light>open_in_new</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <v-divider />

      <v-list class="mt-0" three-line>
        <v-list-item @click="showDeleteModal()">
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('PROFILE.DELETE.TITLE') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
    </div>

    <p class="text-center mt-6">
      <router-link to="/privacy"  class="black--text">
        <span @click="$track('privacy', 'profile')">
          {{ $t('PRIVACY_POLICY') }}
        </span>
      </router-link>
    </p>

    <p class="text-center mb-6">
      <router-link to="/tos"  class="black--text">
        <span @click="$track('privacy', 'terms')">
          {{ $t('TERMS_OF_SERVICE') }}
        </span>
      </router-link>
    </p>

    <p class="text-center my-3">
      <a
        :href="nmhUrl"
        target="_blank"
        class="black--text"
      >
        <span @click="$track('about', 'profile')">
          {{ $t('WHAT_IS_NMH') }}
        </span>
      </a>
    </p>

    <div class="px-2 pt-6 profile-container">
      <ProjectByLogos />
    </div>

    <ClassModeModal
      v-if="!isClassMode"
      v-model="classMode"
    />
    <ClassModeDisableModal
      v-else
      v-model="classMode"
    />
    <EditPicModal v-model="showEditPic" @edit="editPic" />
    <DeleteAccountModal v-model="deleteModal" />
  </GenericLayout>
</template>

<style scoped>
  .profile {
    background: $grey-bg;
  }

  .avatar {
    cursor: pointer;
  }

  .profile-container {
    max-width: 650px;
    margin: 0 auto;
  }

  .v-list--three-line .v-list-item {
    min-height: 0px;
  }
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';
import ClassModeDisableModal from '@/components/profile/ClassModeDisableModal.vue';
import ClassModeModal from '@/components/profile/ClassModeModal.vue';
import DeleteAccountModal from '@/components/profile/DeleteAccountModal.vue';
import EditPicModal from '@/components/profile/EditPicModal.vue';
import ProjectByLogos from '@/components/ProjectByLogos.vue';

export default {
  name: 'Profile',
  components: {
    GenericLayout,
    ClassModeDisableModal,
    ClassModeModal,
    DeleteAccountModal,
    EditPicModal,
    ProjectByLogos,
  },
  data: () => ({
    username: 'UserName123',
    classMode: false,
    showEditPic: false,
    deleteModal: false,
    pic: '',
  }),
  computed: {
    push: {
      set(value) {
        this.$store.dispatch('settings/store', { push: value });
      },
      get() {
        return this.$store.state.settings.push;
      },
    },
    nmhUrl() {
      const urlEs = 'https://nomorehaters.es';
      const urlEn = `${urlEs}/index-en.html`;
      return (this.$i18n.locale === 'es') ? urlEs : urlEn;
    },
  },
  methods: {
    showEditPicModal() {
      this.showEditPic = true;
      this.$track('edit_pic_modal', 'profile');
    },
    editPic(pic) {
      this.pic = pic;
      this.$track('edit_pic', 'profile', pic);
    },
    showClassModeModal() {
      this.classMode = true;
      this.$track('class_mode_modal', 'profile');
    },
    setLocale(locale) {
      this.$store.dispatch('settings/store', { lang: locale });
      this.$track('lang_switch', 'profile', locale);
    },
    share() {
      this.$track('share', 'profile');
      let url = 'https://twitter.com/intent/tweet?url=https%3A%2F%2Fplay.nomorehaters.es&text=Echadle%20un%20ojo%20a%20%23NoMoreHaters%2C%20un%20juego%20para%20detectar%20discurso%20de%20odio';
      if (this.$i18n.locale === 'en') {
        url = 'https://twitter.com/intent/tweet?url=https%3A%2F%2Fplay.nomorehaters.es%2F&text=Check%20out%20%23NoMoreHaters%2C%20a%20game%20that%20will%20teach%20you%20how%20to%20spot%20hate%20speech';
      }
      window.open(url);
    },
    showDeleteModal() {
      this.deleteModal = true;
      this.$track('delete_account_modal', 'profile');
    },
  },
};
</script>
